import React, { useState } from 'react';
import AddIcon from '../../assets/add.svg';
import ImportIcon from '../../assets/import.svg';
import BookIcon from '../../assets/book2.svg';
import { useAsyncEffect } from 'ahooks';
import { useProjectState } from '@starflow/app/store';
import { createUnit, getProcessor } from '@starflow/app/helpers/flow';
import { requestByGet } from '@shakkerai/services';
import { pickLocaleFile, pickPresetData } from '../../utils';
import { convert2CompressedUrl } from '@shakkerai/util-image';
import { setTempState } from '@starflow/app/store';
import { calcType } from '../../../../constants';

const MAX_PRESET_LEN = 5;
const DEF_SIZE = 5;
const UploadWrapper = ({ setIsOpen }) => {
  const [presetData, setPresetData] = useState([]);
  const units = useProjectState('units');
  const nodeMap = useProjectState('nodeMap');
  const { nodes = [] } = units;
  useAsyncEffect(async () => {
    try {
      const res = await requestByGet(`/api/canva/workspace/preset/flow?size=${DEF_SIZE}`);
      if (res.code === 0) {
        setPresetData(res.data);
      }
    } catch (err) {
      console.log(err);
    }
  }, []);
  const handleCreateUnit = (type = 'generator') => {
    const processor = getProcessor(type);
    createUnit({ type, data: processor.defaultData, label: '生成器' + nodes.length + 1 });
  };

  const openPresetModal = (e) => {
    e.stopPropagation();
    setTempState({ exclusiveWindow: 'preset-flow' });
    setIsOpen(false);
  };

  return (
    <div className="pb-4 pt-[10px] w-[250px]">
      <div
        className="flex cursor-pointer px-3 items-center h-[30px] hover:bg-[#424141]"
        onClick={() => handleCreateUnit()}
      >
        <img src={AddIcon} alt="add" className="w-[16px] h-[16px]" />
        <span className="text-white text-xs font-medium ml-2 h-[16px] leading-4 relative top-[1px]">新建生成器</span>
      </div>
      <div
        className="flex cursor-pointer px-3 items-center h-[30px] hover:bg-[#424141]"
        onClick={() => pickLocaleFile(nodeMap, units)}
      >
        <img src={ImportIcon} alt="add" className="w-[16px] h-[16px]" />
        <span className="text-white text-xs font-medium ml-2 relative top-[1px]">导入.flow文件</span>
      </div>
      {presetData.length ? (
        <>
          <div className="flex items-center justify-between px-3 mb-2 mt-1" onClick={(e) => e.stopPropagation()}>
            <span className="text-[#ACACAC]">预设</span>
            <img
              src={BookIcon}
              alt="add"
              className="w-[16px] h-[16px] cursor-pointer"
              onClick={(e) => openPresetModal(e)}
            />
          </div>
          <div className="flex flex-col">
            {presetData.slice(0, MAX_PRESET_LEN).map(({ flowFile, name, imageUrl, type }, idx) => (
              <div
                key={idx}
                className="flex justify-between px-3 items-center h-[40px] cursor-pointer hover:bg-[#424141]"
                onClick={() => pickPresetData(flowFile, nodeMap, units)}
              >
                <div className="flex items-center">
                  <img src={convert2CompressedUrl(imageUrl, 100)} className="w-6 h-8" />
                  <div className="ml-2 text-white">{name}</div>
                </div>
                <div className="text-[#B3B3B3]">{calcType(type)}</div>
              </div>
            ))}
          </div>
        </>
      ) : null}
    </div>
  );
};
export default UploadWrapper;
